<template>
  <div class="d-flex justify-center" :style="{ padding: '10px' }">
    <v-card
      class="d-flex pa-2 flex-column align-center justify-center"
      :style="{
        'margin-bottom': '40px',
        width: '80%',
        'min-height': '550px',
        height: 'fit-content',
      }"
      elevation="0"
    >
      <h3 class="ma-2 text-center">Upload MID</h3>
      <div
        class="d-flex flex-row justify-center align-center flex-wrap"
        :style="{
          'text-align': 'center',
          width: '85%',
          padding: '50px 0px 50px 0px',
        }"
      >
        <div
          class="d-flex flex-column justify-center align-center"
          style="flex: 1"
        >
          <v-row align="center" class="ma-1" style="width: 60%">
            <v-file-input
              label="Data MID (.xlsx)"
              placeholder="Select your files"
              :accept="validate.file_bulk_merchant.type.join()"
              persistent-hint
              outlined
              prepend-inner-icon="mdi-paperclip"
              prepend-icon=""
              v-model="fileBulkMerchant"
              @focus="fileBulkMerchantFocus += 1"
              :error-messages="fileBulkMerchantErrors"
              @change="$v.fileBulkMerchant.$touch()"
              @blur="$v.fileBulkMerchant.$touch()"
            />
          </v-row>

          <v-row v-if="loading" style="width: 60%" class="mb-5">
            <h4>Uploading..</h4>
            <v-progress-linear :indeterminate="loading" />
          </v-row>

          <v-row class="mb-1">
            <v-btn small @click="downloadBaseTemplate">
              Download Template
            </v-btn>
          </v-row>
          <v-row align="center" class="mb-4 mt-2">
            <v-btn
              small
              color="success"
              :disabled="onUpload"
              :loading="onUpload"
              @click="upload"
              :style="{ margin: '5px' }"
            >
              Upload
              <v-icon right dark> mdi-cloud-upload </v-icon>
            </v-btn>
          </v-row>
        </div>
      </div>

      <template>
        <p class="text-justify text-caption">
          Note:<br />
          Maximum 1.000 rows to insert data MID
        </p>
      </template>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { validations } from '../../../store/params';
import { date, showAlert } from '../../../lib/helpers';

export default {
  name: 'StockMidBulkFile',
  mixins: [validationMixin],
  validations: {
    fileBulkMerchant: {
      required() {
        if (this.fileBulkMerchantFocus > 1) {
          return this.fileBulkMerchant != null;
        }
        return true;
      },
      fileType() {
        if (this.fileBulkMerchant != null) {
          return !!validations.file_bulk_merchant.type.includes(
            this.fileBulkMerchant.type.toLowerCase()
          );
        }
        return true;
      },
    },
  },
  mounted() {
    this.downloadTemplate();
  },
  data() {
    return {
      validate: validations,
      fileBulkMerchant: null,
      downloadURL: '',
      fileBulkMerchantFocus: 0,
      searchMerchant: '',
      loadingDownloadFile: false,
    };
  },

  computed: {
    loading() {
      return this.$store.state.stockMid.bulk.loading;
    },
    onUpload() {
      return this.$store.state.stockMid.bulk.onUpload;
    },
    fileBulkMerchantErrors() {
      const errors = [];
      if (!this.$v.fileBulkMerchant.$dirty) return errors;
      if (!this.$v.fileBulkMerchant.required)
        errors.push('File Data Transaction is required for upload');
      if (!this.$v.fileBulkMerchant.fileType)
        errors.push('Incorrect filetype Data Transaction File');
      return errors;
    },
  },
  methods: {
    downloadBaseTemplate() {
      window.location.href = this.downloadURL;
    },

    upload() {
      this.$store.commit('stockMid/bulk/setUpdatedBulk', false);
      this.fileBulkMerchantFocus = 2;
      this.$v.fileBulkMerchant.$touch();
      if (!this.$v.fileBulkMerchant.$error) {
        this.$store
          .dispatch('stockMid/bulk/bulkUpload', {
            file: this.fileBulkMerchant,
            date,
          })
          .then((res) => {
            if (res) {
              showAlert(
                this.$store,
                'Proses Upload MID Berhasil !',
                'mdi-check-circle',
                'green'
              );
            }
          });
      }
    },
    downloadTemplate() {
      this.$store
        .dispatch('stockMid/bulk/downloadFile', {
          date,
          id: false,
          type: 'template',
        })
        .then((response) => {
          if (response) {
            this.downloadURL = response.download;
          }
        });
    },
  },
};
</script>
